// Copyright (c) 2017 Deere & Company

import '../../details/components/index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import ClaimSummaryPanel from './claim-summary-panel';
import {FormattedMessage} from 'react-intl';
import ReportGrid from '../../../reports/shared/components/report-grid';
import ReportHeader from '../../../reports/shared/components/report-header';
import ReportHiddenColumns from '../../../reports/shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import WarrantyAgGridDatePicker from '../../../reports/shared/components/ag-grid-date-picker';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getColumnDefinitions} from '../constants/column-definitions';
import {resizeReport} from '../../shared/services/resize-report';

function handleGridApiDefinition(params) {

    const reportVariantParams = {
        isInitialLoad: this.isInitialLoad,
        layouts: this.layouts,
        selectedLayout: this.selectedLayout
    };

    this.actions.createAgGridApi(params.api, params.columnApi);

    this.actions.getReportLayouts('claim-reimbursement-summary', params.columnApi, params.api, reportVariantParams);

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleUnpaidFilters() {

    if (this.queryParams.unpaidFilter) {

        const unpaidFilters = this.queryParams.unpaidFilter.split(',');

        unpaidFilters.forEach(filter => {

            const unpaidFilterComponent = this.gridApi.getFilterInstance(filter);

            unpaidFilterComponent.setType('greaterThan');
            unpaidFilterComponent.setFilter(0);

        });

        this.gridApi.onFilterChanged();

    }

}

function handleRemoveFilters() {

    this.gridApi.setFilterModel(null);
    this.gridApi.onFilterChanged();

}

function cleanseQueryParams(params) {

    const cleanParams = {};

    const allowedParams = ['leadAccount', 'city', 'account', 'postingDateFrom', 'postingDateTo'];

    Object.keys(params).forEach(paramKey => {

        if (allowedParams.includes(paramKey)) {

            cleanParams[paramKey] = params[paramKey];

        }

    });

    return cleanParams;

}

class ReimbursementSummaryClaims extends Component {

    async componentWillMount() {

        this.props.actions.readClaimSummary(cleanseQueryParams(this.props.queryParams));
        await this.props.actions.getReportLayouts('claim-reimbursement-summary');
        this.props.actions.updateGridLayouts(this.props.layouts, getColumnDefinitions());

    }

    componentWillReceiveProps = nextProps => {

        if (this.props.queryParams !== nextProps.queryParams) {

            this.props.actions.readClaimSummary(cleanseQueryParams(nextProps.queryParams));

        }

    };

    componentDidUpdate = () => {

        this.props::handleUnpaidFilters();

        if (this.props.claimSummary.data.length) {

            resizeReport();

        }

        if (this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    };

    componentWillUnmount = () => {

        this.props.actions.resetReportVariant();

    };

    render = () => {

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (

            <main className='reimbursement-summary-main'>
                <header className='reimbursement-summary-header'>
                    <h2 className='header-title'>
                        <FormattedMessage
                            id='CLAIMS'
                        />
                    </h2>
                </header>
                <ClaimSummaryPanel
                    claimCount={this.props.claimSummary.data.length}
                    queryParams={this.props.queryParams}
                    removeFilter={this.props::handleRemoveFilters}
                />
                {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                <ReportHeader
                    columnApi={this.props.columnApi}
                    gridApi={this.props.gridApi}
                    reportName='claim-reimbursement-summary'
                />
                <ReportGrid
                    columnDefs={getColumnDefinitions()}
                    gridOptions={gridOptions}
                    headerHeight={100}
                    localeText={getAgGridLocaleText()}
                    onColumnVisible={this.props::onColumnRemoved}
                    onGridReady={this.props::handleGridApiDefinition}
                    rowData={this.props.claimSummary.data}
                    suppressNoRowsOverlay={true}
                />
            </main>
        );

    }

}

ReimbursementSummaryClaims.displayName = 'ReimbursementSummaryClaims';
ReimbursementSummaryClaims.propTypes = {
    actions: PropTypes.object.isRequired,
    claimSummary: PropTypes.object.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    queryParams: PropTypes.object.isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout)
};

export default ReimbursementSummaryClaims;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/claims/components/index.js